/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import Facebook from 'components/Icons/Facebook.svg';
import Instagram from 'components/Icons/Instagram.svg';
import Pinterest from 'components/Icons/Pinterest.svg';
import Twitter from 'components/Icons/Twitter.svg';
import Url from 'components/Icons/Url.svg';
import Yelp from 'components/Icons/Yelp.svg';

interface Urls {
  instagram_url?: string;
  facebook_url?: string;
  yelp_url?: string;
  twitter_url?: string;
  website_url?: string;
  pinterest_url?: string;
}

type TUrlsKeys = keyof Urls;

const links: {
  name: TUrlsKeys;
  prefix: string;
  suffix: string;
  Icon: React.ElementType;
}[] = [
  {
    name: 'facebook_url',
    prefix: 'https://www.facebook.com/',
    suffix: 'Facebook',
    Icon: Facebook,
  },
  {
    name: 'twitter_url',
    prefix: 'https://twitter.com/',
    suffix: 'Twitter',
    Icon: Twitter,
  },
  {
    name: 'instagram_url',
    prefix: 'https://www.instagram.com/',
    suffix: 'Instagram',
    Icon: Instagram,
  },
  {
    name: 'pinterest_url',
    prefix: 'https://www.pinterest.com/',
    suffix: 'Pinterest',
    Icon: Pinterest,
  },
  {
    name: 'yelp_url',
    prefix: 'https://www.yelp.com/',
    suffix: 'Yelp',
    Icon: Yelp,
  },
  { name: 'website_url', prefix: '', suffix: 'Official Site', Icon: Url },
];

export interface NavItemSocialProps {
  className?: string;
  urls: Urls;
}

const SocialMediaLinks = ({ className, urls }: NavItemSocialProps) => {
  if (urls && !Object.values(urls).some(Boolean)) {
    return null;
  }

  return (
    <div className={className}>
      {links.map(({ name, prefix, suffix, Icon }) => {
        const url = urls[name] as string;

        return (
          urls[name] && (
            <a
              key={name}
              href={url?.startsWith('http') ? url : `${prefix}${url}`}
              target="_blank"
              rel="noreferrer"
              title={`Link to ${suffix} profile`}
            >
              <Icon />
            </a>
          )
        );
      })}
    </div>
  );
};

export { SocialMediaLinks };
